import { cn } from "@theprelude/core";

export const DiscussIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m9.33366 14.9987-1.86667-2.3333h-3.46666c-.17682 0-.34638-.0703-.47141-.1953-.12502-.125-.19526-.2946-.19526-.4714v-7.26467c0-.17681.07024-.34638.19526-.4714.12503-.12503.29459-.19527.47141-.19527h10.66667c.1768 0 .3464.07024.4714.19527.125.12502.1953.29459.1953.4714v7.26467c0 .1768-.0703.3464-.1953.4714s-.2946.1953-.4714.1953h-3.4667zm1.22604-3.6667h3.4406v-5.9313h-9.33331v5.9313h3.44067l1.226 1.532zm-9.22604-9.99997h11.33334v1.33333h-10.66667v7.33334h-1.333338v-8c0-.17681.070238-.34638.195262-.47141.125025-.12502.294596-.19526.471406-.19526z" />
  </svg>
);
